import { Notification, NotificationProps, Group } from '@mantine/core';
import { cva, type VariantProps } from 'class-variance-authority';
import styles from './Callout.module.css';
import {
    IconInfoCircle,
    IconCircleCheck,
    IconAlertTriangle,
    IconAlertCircle,
    IconProps,
} from '@tabler/icons-react';
import { FC } from 'react';

const calloutVariants = cva(styles.base, {
    variants: {
        status: {
            neutral: styles.neutral,
            info: styles.info,
            positive: styles.positive,
            caution: styles.caution,
            negative: styles.negative,
            disabled: styles.disabled,
            prominent: styles.prominent,
            minimal: styles.minimal,
        },
    },
    defaultVariants: {
        status: 'neutral',
    },
});

const statusToIconMap: Record<NonNullable<VariantProps<typeof calloutVariants>['status']>, FC<IconProps>> = {
    neutral: IconInfoCircle,
    info: IconInfoCircle,
    positive: IconCircleCheck,
    caution: IconAlertTriangle,
    negative: IconAlertCircle,
    disabled: IconInfoCircle,
    prominent: IconInfoCircle,
    minimal: IconInfoCircle,
};

type CalloutProps = NotificationProps &
    VariantProps<typeof calloutVariants> & {
        /**
         * Renders a icon in the top right of the callout. Defaults to true
         */
        withIcon?: boolean;
    };

export const Callout = ({ status, title, withIcon = true, ...props }: CalloutProps) => {
    const Icon = statusToIconMap[status ?? 'neutral'];
    return (
        <Notification
            className={calloutVariants({ status })}
            title={
                <Group justify={'space-between'}>
                    {title}
                    {withIcon && <Icon className={'datavant-Callout-icon'} />}
                </Group>
            }
            {...props}
        />
    );
};
